module.exports = __webpack_public_path__ + "img/advantage-security.33d8660b.svg";